import "./Contact.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import StepsFromTheSacred from "./sections/StepsFromTheSacred";
import ProjectIntake from "./sections/ProjectIntake";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import ComprehensiveFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <VoltMainHeader />
      <StepsFromTheSacred />
      <ProjectIntake />
      <FrequentlyAskedQuestions />
      <ComprehensiveFooter />
    </div>;
}